import React from 'react';
import classNames from 'classnames';

// components
import Icon from '../../components/icon';
import Tooltip from '../../components/tooltip';
import { Div, Flex } from '../../components/box';
import Text from '../../components/text';
import { H4 } from '../../components/title';
import MenuPopover from '../../components/menu-popover';

// constants
import { variants as iconVariants } from '../../components/icon/style';

import { NavButton } from '../../components/header';
import Panel from '../../components/panel';
import NotificationItem from './notifications-item';

export interface NotificationsPopoverProps {
  hasAlerts?: boolean;
  numOfAlerts?: number;
  variant?: keyof typeof iconVariants;
  children?: React.ReactNode;
  notificationsTitle?: string;
  notificationsEmptyMessage?: string;
}

const NotificationsPopoverComponent = ({
  notificationsTitle = 'Notifications',
  notificationsEmptyMessage = 'No notifications to show',
  hasAlerts,
  numOfAlerts,
  variant,
  children,
}: NotificationsPopoverProps) => {
  return (
    <MenuPopover size={'md'} data-name={'notifications-popover'}>
      <Tooltip side={'bottom'} text={notificationsTitle}>
        <div>
          <MenuPopover.Button
            as={NavButton}
            aria-label={notificationsTitle}
            className={classNames('box-imob-notification-center')}
            data-testid={'navbar-notification-button'}
          >
            <Icon position={'relative'} variant={variant} size={'xxl'} name="BELL">
              {hasAlerts && (
                <Icon.Badge variant={'negative-dark'} size={'md'}>
                  {numOfAlerts}
                </Icon.Badge>
              )}
            </Icon>
          </MenuPopover.Button>
        </div>
      </Tooltip>
      <MenuPopover.Items>
        <MenuPopover.Label>
          <Panel margin={'xs'} paddingBottom={'xs'} variant={'border-bottom-gray300'}>
                        <H4
              textTransform={'capitalize'}
              weight={500}
              marginBottom={'none'}
              align={'left'}
              variant={'gray900'}
              size={'sm'}
            >
              {notificationsTitle}
            </H4>
          </Panel>
        </MenuPopover.Label>
        <Flex flexDirection={'column'}>
          {hasAlerts ? (
            <Div maxHeight={300} overflowY={'auto'}>
              {children}
            </Div>
          ) : (
            <Flex justifyContent={'center'} padding={'md'}>
              <Text variant={'gray800'}>{notificationsEmptyMessage}</Text>
            </Flex>
          )}
        </Flex>
      </MenuPopover.Items>
    </MenuPopover>
  );
};

const NotificationsPopover = (props: NotificationsPopoverProps) => <NotificationsPopoverComponent {...props} />;

NotificationsPopover.Item = NotificationItem;

export default NotificationsPopover;
